import styled from 'styled-components'  

export const InputContainer = styled.div.attrs({ 
})`          
    position: relative; 
    width: 100%;
    ${
        props => props.outline ? `
            border: .5px solid var(--lightgrey-color);
        ` : ``
    }
    border-radius: 5px;
    overflow: hidden;
`;

export const InputLabel = styled.div.attrs({ 
})`          
    font-size: 12px; 
    color: var(--primary-color);
`;

export const InputInput = styled.input.attrs({ 
})`          
    border: 0;
    height: 52px;
    color: var(--lightgrey-color);
    font-size: 14px;
    outline: none;
    width: 100%;
    padding: 0 8px;
    &::placeholder{
        color: var(--lightgrey-color);
    }
`;

export const InputAction = styled.div.attrs({ 
})`          
    height: 52px;
    width: 52px; 
    background-color: var(--white-color);

    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    bottom: 0;
    right: 0;
`;

export const InputIcon = styled.img.attrs({ 
})`
`;